var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex mt-2"},_vm._l((_vm.params.data.intentions),function(intention,index){return _c('vs-chip',{key:index,staticStyle:{"height":"30px"}},[_c('span',[_vm._v(_vm._s(intention))])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }